import { Flex } from "@chakra-ui/react";
import { format } from "date-fns";
import { useCallback, useContext, useState } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { useParams } from "react-router-dom";

import { PopupReportOrderInput } from "~/src/__generated__/schema";
import { PopupPatternNameReportContainer_Query } from "~/src/__relay_artifacts__/PopupPatternNameReportContainer_Query.graphql";
import { DateRangeContext } from "~/src/components/features/global/HeaderNavigation/DateRangeField";
import { usePopupReportFilterCache } from "~/src/lib/hooks";

import {
  PopupReportFilterFormValues as FormValues,
  PopupPatternNameReport,
  PopupPatternNameReportFilterButton,
} from "./presentations";

const query = graphql`
  query PopupPatternNameReportContainer_Query(
    $kind: PopupReportKindInput!
    $filter: PopupReportFilterInput!
    $order: PopupReportOrderInput
    $slug: String!
  ) {
    site(slug: $slug) {
      ...PopupPatternNameReport_site
    }
  }
`;

export const PopupPatternNameReportContainer = () => {
  const { siteSlug = "" } = useParams();

  const [sort, setSort] = useState<PopupReportOrderInput>({
    value: "READY_USER",
    isDesc: false,
  });

  const initialFilterValues: FormValues = {
    sourceId: null,
    device: null,
    popupNames: [],
    funnelIds: [],
    popupIds: [],
    pageKind: null,
    pageIds: [],
  };

  const { filterValues, setFilterValues } = usePopupReportFilterCache({
    cacheKey: `PopupPatternNameReport_${siteSlug}`,
    initialFilterValues,
  });

  const {
    dateRange: [startOn, endOn],
  } = useContext(DateRangeContext);

  const handleSortClick = useCallback((params: any) => {
    setSort({
      value: params.field,
      isDesc: params.direction === "DESC" ? true : false,
    });
  }, []);

  const { site } = useLazyLoadQuery<PopupPatternNameReportContainer_Query>(
    query,
    {
      kind: {
        value: "POPUP_NAME",
        isDateExist: false,
      },
      filter: {
        startDate: format(startOn, "yyyy-MM-dd"),
        endDate: format(endOn, "yyyy-MM-dd"),
        source: filterValues.sourceId,
        device: filterValues.device,
        popupNames: filterValues.popupNames,
      },
      order: sort,
      slug: siteSlug,
    }
  );

  return (
    <>
      <Flex justifyContent={"end"}>
        <PopupPatternNameReportFilterButton
          filterValues={filterValues}
          onSubmit={setFilterValues}
        />
      </Flex>
      <PopupPatternNameReport siteRef={site} onSortClick={handleSortClick} />
    </>
  );
};
